export default "__VITE_ASSET__BTpmf7L$__"